import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formattedDate',
    standalone: true
})
export class FormattedDatePipe implements PipeTransform {

    transform(dateString: string | null | undefined): string {
        if (!dateString) {
            return '\u2014';
        }
        return new Date(dateString + 'Z').toLocaleString(undefined, {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        });
    }

}
